import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {colorLike} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {z} from "zod"

export const DisplayMode = z.union([z.literal("normal"), z.literal("mask"), z.literal("low-pass")])

export const CorrectionMode = z.union([z.literal("offset"), z.literal("modulation")])

export const BlurSettings = z.object({
    enabled: z.boolean(),
    smoothingDistance: z.number().min(0),
})

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            sourceMean: colorLike.or(z.number()).optional(),
            maskImage: anyImageOpResult.optional(),
            blurSettingsH: BlurSettings,
            blurSettingsV: BlurSettings,
            wrapAround: z.boolean(),
            intensity: z.number().min(0).max(1).optional().default(1),
            angleOffset: z.number().min(-180).max(180).optional().default(0),
            displayMode: DisplayMode.optional().default("normal"),
            correctionMode: CorrectionMode.optional().default("modulation"),
        }),
    },
}
